export default function handleOtp(params) {
  const emailIdRaw = params.get("emailId") || "";

  let emailId = "";

  try {
    emailId = emailIdRaw
      ? decodeURIComponent(atob(emailIdRaw))
      : "";
  } catch (error) {
    console.error("Error decoding OTP email:", error);
  }

  return {
    action: "otp",
    emailId,
  };
}